import AddPartner from '../components/Partners/AddPartner';

// Standalone route for the same form the list page shows in its Drawer.
// The form itself renders no chrome, so the page supplies it.
export default function PartnerAddPage() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-8">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Нов партнер</h2>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <AddPartner />
      </div>
    </div>
  );
}
